export const servicesData = [
  {
    backgroundImage: "/images/rectangle.png",
    logoSrc: "/images/graphic_designing_logo.png",
    title: "Graphic Designing",
    heading:
      "A key component of your brand identity and can help you stand out from the competition.",
    services: [
      "Web Design",
      "UI / UX Design",
      "Illustration",
      "Marketing & Advertising Design",
    ],
    reverse: false,
  },
  {
    backgroundImage: "/images/rectangle.png",
    logoSrc: "/images/software_development_logo.png",
    title: "Software Development",
    heading: "The best way to predict the future is to invent it.",
    services: [
      "Customization and Extensibility",
      "DBMS",
      "Software Characteristics",
      "Scalability",
    ],
    reverse: true,
  },
  {
    backgroundImage: "/images/rectangle.png",
    logoSrc: "/images/game_development_logo.png",
    title: "Game Development",
    heading:
      "Using technical knowledge and skills to turn game concepts and ideas into reality.",
    services: [
      "Brainstorming & Processing",
      "Level design",
      "Monetization strategy and plans",
      "User flow and UX charts",
    ],
    reverse: false,
  },
  {
    backgroundImage: "/images/rectangle.png",
    logoSrc: "/images/generative_ai_logo.png",
    title: "Generative AI",
    heading:
      "Artificial intelligence and generative AI may be the most important technology of any lifetime.",
    services: [
      "Data analytics",
      "Chatbots",
      "Machine learning",
      "User personalization",
    ],
    reverse: true,
  },
  {
    backgroundImage: "/images/rectangle.png",
    logoSrc: "/images/content_marketing_logo.png",
    title: "Content Marketing",
    heading:
      "Good marketing makes the company look smart. Great marketing makes the customer feel smart.",
    services: [
      "Targeted Audience",
      "Business goals",
      "Maintain a consistent brand message",
      "Generating leads",
    ],
    reverse: false,
  },
];
